module.exports = __webpack_public_path__ + "img/archive.71da8084.svg";